module.exports = __webpack_public_path__ + "img/61-574a0e.png";